import { flattenCaughtMessage } from './errorUtils'

const PERMISSION_MESSAGE_SIGNALS = [
  'a user gesture is required',
  'notallowederror',
  'permission dismissed',
  'play() failed because the user',
  'not allowed by the user agent',
  'the play() request was interrupted',
] as const

/**
 * Browser autoplay / gesture policy errors during live-class Zoom SDK flows.
 * The UI already handles these; they should not pollute Sentry as errors.
 */
export function isExpectedLiveClassBrowserPolicyError(reason: unknown): boolean {
  if (reason == null) {
    return false
  }

  if (reason instanceof Error && reason.name === 'NotAllowedError') {
    return true
  }

  if (
    typeof reason === 'object' &&
    reason !== null &&
    'name' in reason &&
    String((reason as { name: unknown }).name) === 'NotAllowedError'
  ) {
    return true
  }

  const message = flattenCaughtMessage(reason).toLowerCase()
  if (!message) {
    return false
  }

  return PERMISSION_MESSAGE_SIGNALS.some((signal) => message.includes(signal))
}

export function isLiveClassSentryEvent(
  event?: {
    tags?: Record<string, unknown>
    transaction?: string
    request?: { url?: string }
  } | null,
): boolean {
  if (!event) {
    return false
  }
  const transaction = event.transaction
  if (typeof transaction === 'string' && transaction.includes('live-class')) {
    return true
  }

  const liveClassTransactionTag = event.tags?.['liveClass.transaction']
  if (
    typeof liveClassTransactionTag === 'string' &&
    liveClassTransactionTag.includes('live-class')
  ) {
    return true
  }

  if (event.tags?.['liveClass.state'] !== undefined) {
    return true
  }

  const url = event.request?.url
  return typeof url === 'string' && url.includes('live-class-view')
}
